import { createFileRoute } from "@tanstack/react-router";
import { Banking } from "@/components/Banking";

function RouteComponent() {
  return <Banking />;
}

export const Route = createFileRoute("/_authenticated/banking/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
